import { MdlDialogReference } from '@angular-mdl/core';
import { Component, Inject, InjectionToken, ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';
import { includes, isEmpty } from 'lodash';

export const FILTER_NAME_DIALOG_DATA = new InjectionToken('FilterName');

export interface FilterNameDialogData {
    formTitle: string;
    filterName: string;
    occupiedFilterNames: string[];
}

export interface FilterNameDialogResult {
    saveChanges: boolean;
    filterName?: string;
}

@Component({
    selector: 'filter-name-dialog',
    styles: [require('./filter-name-dialog.component.scss')],
    template: require('./filter-name-dialog.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterNameDialogComponent implements AfterViewInit {
    public formTitle: string;
    public control: FormControl;

    constructor(
        private ref: ChangeDetectorRef,
        private dialog: MdlDialogReference,
        @Inject(FILTER_NAME_DIALOG_DATA) dialogData: FilterNameDialogData
    ) {
        this.formTitle = dialogData.formTitle;
        this.control = new FormControl(dialogData.filterName);
        const occupiedFilterNames = dialogData.occupiedFilterNames.map(f => f.trim().toLocaleLowerCase());
        this.control.setValidators([this.nonEmptyNameValidator(), this.uiqueNameValidator(occupiedFilterNames)]);
    }

    public get validationError(): string {
        if (this.control.hasError('emptyName')) {
            return 'Name is required';
        }
        if (this.control.hasError('nonUniqueName')) {
            return 'Filter with the same name already exists';
        }
        return '';
    }

    public ngAfterViewInit() {
        //https://github.com/mseemann/angular2-mdl/issues/145
        //https://github.com/angular/angular/issues/10816#issuecomment-307638674
        this.ref.markForCheck(); 
    }

    public onOkClick() {
        const result: FilterNameDialogResult = {
            saveChanges: true,
            filterName: this.filterName
        };
        this.dialog.hide(result);
    }

    public onCancelClick() {
        const result: FilterNameDialogResult = {
            saveChanges: false
        };
        this.dialog.hide(result);
    }

    private nonEmptyNameValidator() {
        return (): ValidationErrors => {
            const isInvalid = isEmpty(this.filterName);
            return isInvalid ? { 'emptyName': true } : null;
        };
    }

    private uiqueNameValidator(occupiedFilterNames: string[]) {
        return (): ValidationErrors => {
            const isInvalid = !isEmpty(this.filterName) && includes(occupiedFilterNames, this.filterName.toLocaleLowerCase());
            return isInvalid ? { 'nonUniqueName': true } : null;
        };
    }

    private get filterName(): string {
        return this.control.value ? this.control.value.trim() : null;
    }
}